
<script>
import BarList from '../components/bar-list'
import { getText, formatDate, formatValue, formatDataHoraExtenso } from '../shared/utils'
import { apiORDS, apiAutNFe, apiDownloadPDF, apiDownload } from '../shared/api-functions'
import { SysVars } from '../main';
// import { VueOfflineMixin } from 'vue-offline',
import VarejoEmissaoCupom from './varejo-emissao-cupom'
import DevolucaoForm from './varejo-devolucao-form.vue'
import PedidoFiltro from '../components/pedido-filtro'
import apiPedido from "../api/api-pedido.js";
import autorizaNFe from "../api/api-nfe.js";

export default {
  props: {
    index: '',
    codvabertura: '',
  },

  components: {
    BarList, VarejoEmissaoCupom, DevolucaoForm, PedidoFiltro
  },

  data() {

    return {
      showForm: false, //exibe a tela de manutencao
      crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
      vend: '',
      metadata: this.$store.getters.getEntities.metadata,
      filter: '',
      offset: false,

      nfSearch: null,
      textSearch: null,

      showDevolucao: false,
      codpedv: null,
      pedv: null,
      tipo_devolucao: false,

      query: {
        codusuario: null,
        codequipe: null,
        text: null,
        after: null,
        before: null,
        codstatus: null,
      },
      caixasList: null,
      isOnline: true,
      cupomCodpedv: null,
      showEmissaoCupom: false,

      actions: [
        { action: 1, label: 'Configurar PDV' },
        { action: 2, label: 'Cadastro de Caixas' },
        { action: 3, label: 'Formas de Pagamento' },
      ]

    }
  },

  computed: {
    varejoList: function () {
      return this.$store.getters.getPedvList
    },
    nextPage: function () {
      return this.$store.getters.getNextPage
    }
  },

  filters: {
    getText: function (value, metadata) {
      return getText(value, metadata)
    },

  },

  methods: {
    scroll() {
      window.onscroll = () => {
        if (this.offset || this.nextPage == 0)
          return
        let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= (document.documentElement.offsetHeight - 2)

        if (bottomOfWindow) {
          this.offset = true
          this.loadData(true)
        }
        SysVars.scrollPosition = document.documentElement.scrollTop
      }
    },

    horaStatus(hora) {
      return formatDataHoraExtenso(hora)
    },

    statusColor: function (stpedv, tppedv) {
      let color = 'badge-green'
      if (stpedv == 'C' || stpedv == 'R' || tppedv == 'R') {
        color = 'badge-red'
      } else if (stpedv == 'F') {
        color = 'badge-blue'
      } else if (tppedv == 'O') {
        color = 'badge-orange'
      } else if (stpedv == 'D') {
        color = 'badge-warning'
      } else if (tppedv == 'P') {
        color = 'badge-green'
      }
      return color
    },

    textST(item) {
      let text = 'Venda'
      if (item.tppedv == 'O') {
        text = 'Orçamento'
      } else if (item.tppedv == 'R') {
        text = 'Orçamento Perdido'
        return text
      }

      if (item.stpedv == 'C') {
        text = text + ' Cancelada'
      } else if (item.stpedv == 'R') {
        text = text + ' Rejeitado'
      } else if (item.stpedv == 'A') {
        text = text + ' Em Aprovação'
      } else if (item.stpedv == 'F') {
        text = 'Nota Emitida'
      } else if (item.stpedv == 'D') {
        text = text + ' em Espera'
      }
      return text
      // return getText(value, this.metadata.pedv.stpedv)
    },


    handleConnectivityChange(status) {
      this.isOnline = status.online;
    },

    handleCompletEdit(cod) {
      //abre a tela de edicao
      this.crud = SysVars.crudU;
      this.codpedv = cod
      this.$router.push('/pedido/' + this.codpedv)
      this.showForm = true;
    },

    handleNew() {
      //inclusao de registro
      this.crud = SysVars.crudI
      this.codpedv = ''

      if (this.codvabertura) //quando a chamada foi por dentro do form de varejo
        this.$emit('resultadolist', null, '')
      this.$router.push('/varejo/0')
      this.showForm = true;
    },

    handleMore() {
      this.offset = true
      this.loadData()
    },

    closeForm() {
      this.showForm = false
      this.loadData()
    },

    closeFormDevolucao() {
      this.showDevolucao = false
      this.scroll()
    },

    changeFiltros() {
      this.query.text = null
      this.query.nf = null
      this.nfSearch = null
      this.loadData()
    },

    handleTextSearch() {
      //efetua a pesquisa
      this.query.text = this.textSearch.toUpperCase()
      this.query.nf = null
      this.nfSearch = null
      this.loadData()
    },

    handleNfSearch() {
      //efetua a pesquisa
      this.query.text = null
      this.query.nf = this.nfSearch
      this.textSearch = null
      this.loadData()
    },

    handleChangeMonth(filter, startDate, endDate) {
      this.query.after = startDate
      this.query.before = endDate
      this.query.text = null
      this.query.nf = null
      this.textSearch = null
      this.nfSearch = null
      this.loadData()
    },

    handleSearch(value) {
      this.textSearch = value
      this.handleTextSearch();
    },

    handleRefresh() {
      this.query.text = null
      this.query.nf = null
      this.textSearch = null
      this.nfSearch = null
      this.loadData()
    },

    handleButtonMoreActions (action) {
      if (action == 1) {
        this.$router.push('guiaempresa/pdv?b=varejolist')
      }
      if (action == 2) {
        this.$router.push('caixas')
      }
      if (action == 3) {
        this.$router.push('fpag')
      }
    },

    handleFaturarVenda (pedv, tipo) {
      this.pedv = {...pedv}
      let esp = ''
      if (tipo == 'NFCe') 
        esp = '65'
      else  
        esp = '55'
      let self = this
      
      this.apiGerarNF(esp).then(function () {
        let tipo = self.$certificadoCheck(self.pedv.codfil)
        if (tipo == 'A1') {
          self.autorizaNFeA1(self.pedv.nf, self.NFeResponseCallbackA1).then(function () {
          });
        } else if (tipo == "A3") {
          self.autorizaNFeA3(self.pedv.nf, self.NFeResponseCallbackA3).then(function() {
          });
        }
      });
    },

    NFeResponseCallbackA3(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO A3
      if (response.status != "success") {
        this.$erpToastError(response.message);
      } else {
        if (response.response && response.response.nf.length > 0 && response.response.nf[0].cstat == "100") {
          this.$erpToastSuccess("NFe Autorizada");
          apiDownloadPDF(this, "print/danfe/" + response.response.nf[0].codnf, null, null, true);
        } 
        else {
          this.$erpToastError(response.response.xmotivo);
          this.$router.push("/nf/" + response.response.nf[0].codnf + "?tipo=view");
        }
      }
    },

    async NFeResponseCallbackA1(response) {
      let rejeitada = false;
      if (response.data) {
        if (!response.data.errmessages) {
          if (response.data.nf.length > 0) {
            if (response.data.nf[0].cstat != "100") {
              rejeitada = true;
            }
          } else {
            rejeitada = true;
          }
        }
      }

      if (rejeitada) {
        this.$erpToastError('NFe Rejeitada');
        this.$router.push("/nf/" + this.pedv.nf.codnf + "?tipo=view");
      }

      //CASO NF-e AUTORIZADA SERÁ ABERTO TELA DE IMPRESSÃO
      if (response.data.nf.length > 0) {
        if (response.data.nf[0].codnf) {
          this.$erpToastSuccess("NFe Autorizada");
          apiDownloadPDF(this, "print/danfe/" + response.data.nf[0].codnf, null, null, true);
        }
      }
    },

    loadData() {
      //this.$store.dispatch('loadVend', { filter: this.filter, page: this.nextPage } )
      //this.offset = ''

      let param = {}
      param.query = ''
      if (this.query.after)
        param.query = param.query + 'after=' + this.query.after + '&'
      if (this.query.before)
        param.query = param.query + 'before=' + this.query.before + '&'

      if (this.query.espera)
        param.query = param.query + 'filtroorigem=4&'
      else
        param.query = param.query + 'filtroorigem=3&'
      
      if (this.codvabertura)
        param.query = param.query + 'codabertura=' + this.codvabertura + '&'
      if (this.query.text)
        param.query = param.query + 'text=' + this.query.text + '&'
      if (this.query.nf)
        param.query = param.query + 'nf=' + this.query.nf + '&'
      if (this.offset)
        param.query = param.query + 'poffset=' + this.nextPage + '&'

      param.query = param.query.trim()
      if (param.query.endsWith('&'))
        param.query = param.query.slice(0, -1)

      this.$store.dispatch('loadPedvList', param)
      this.offset = false

    },

    async loadDataCaixas () {
      let self = this
      self.caixasList = []
      await apiORDS(this.$store.getters.urlOrds + 'varejo/caixas', null, true).then((result) => {
        if (!result)
          return;
          for (let index = 0; index < result.items.length; index++) {
            if (result.items[index].aberto == 'S')
              self.loadDetCaixa(result.items[index])
            else {
              let caixa = {
                caixa: result.items[index].caixa,
                operadorabertura: null,
                resumoVendas: { total: 0 },
                aberto: false,
                status: 'Caixa Fechado',
              }
              self.caixasList.push(caixa)
            }
          }
      })
    },

    loadDetCaixa (caixa) {
      let self = this
      apiORDS(this.$store.getters.urlOrds + 'varejo/controlecaixa/' + caixa.codvabertura, null, true).then((result) => {
        if (!result)
          return;
        self.caixasList.push(result)
      })
    },

    handleBarGrid(stpedv) {
      let options = { barDefault: true, btnView: !this.tipo_devolucao, btnEdit: false, }

      if (stpedv == 'D')
        options.btnEdit = true
      
      if (stpedv == 'P' || stpedv == 'F')
        options.btnDevolucao = this.tipo_devolucao

      return options
    },

    handleAction(act, obj) {
      if (act == 12) {
        this.handleFaturarVenda(obj, 'NFe')
        return
      }
      if (act == 10) {
        this.handleFaturarVenda(obj, 'NFCe')
        return
      }

      if (act == 16) {
        //visualizacao do XML da NFE
        if (obj.stnf !='10') {
          this.$erpToastWarning('A nota fiscal não está autorizada')
          return
        }
        var data = { codnf: obj.codnf, chave: obj.chave, tipo: 'NFE' }
        apiDownload(this, 'print/xmlnfe/', data, 'post')
      }

      if (act == 15) {
        //impressao da danfe em PDF
        if (obj.esp == '59') {
          let paramsimp = '&codnf=' + obj.codnf
          this.$executaExtensaoChromeSAT(obj.codnf, 'imp', this.PDFResponseCallbackSAT, paramsimp)
          return
        }
        if (obj.stnf !='10')
          this.$erpToastWarning('A nota fiscal não está autorizada')
        else   
          apiDownloadPDF(this, 'print/danfe/' + obj.codnf)
      }

      if (act == 13) {
        this.cupomCodpedv = obj.codpedv
        this.showEmissaoCupom = true
      }

      if (act == 20) {
        this.handleDevolucao(obj.codpedv)
      }
      if (act == 14) {
        this.handleCompletEdit(obj.codpedv)
      }
      if (act == 21) {
        this.handleEdit(obj.codpedv)
      }


    },

    handleDevolucao(codpedv){
        this.codpedv = codpedv
        this.crud = SysVars.crudInsert
        window.onscroll = null
        this.showDevolucao = true
    },

    getActions(pedv) {
      let actions = []

      if (this.tipo_devolucao)
        return

      if (pedv.stpedv == 'P') {
        actions.push({ action: 10, label: 'Emitir NFc-e' })
        // actions.push({ action: 11, label: 'Emitir SAT' })
        actions.push({ action: 12, label: 'Emitir NF-e' })
        actions.push({ action: 13, label: 'Cupom Não Fiscal' })
        // actions.push({ action: 14, label: 'Visualização Completa' })
      }

      if (pedv.stpedv == 'F') {
        actions.push({ action: 15, label: 'Danfe PDF' })
        actions.push({ action: 16, label: 'Download do XML' })
      }

      if (pedv.stpedv == 'P' || pedv.stpedv == 'F') {
        actions.push({ action: 20, label: 'Lançar Devolução' })
      }
      // actions.push({ action: 21, label: 'Visualização' })
      return actions
    }

  },

  mixins: [apiPedido, autorizaNFe],

  created() {

    this.$on("online", () => {
      self.handleConnectivityChange({ online: true });
    });

    this.$on("offline", () => {
      self.handleConnectivityChange({ online: false });
    });

    this.showForm = false
    this.loadData()
    this.loadDataCaixas()

    this.tipo_devolucao = false
    if (this.$route.params) {
      if (this.$route.params.tipo == 'devolucao')
        this.tipo_devolucao = true
    }

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })
  },

  mounted() {
    this.scroll()
  },

  destroyed () {
    window.onscroll = null
  },

}

</script>

<template>
  <div>
    <div class="relative" id="list" v-if="!showForm && !showDevolucao">
      <bar-list :refresh-button="false" :new-button="true" :pdf-button="false" :xls-button="false" :filter-month="true"
        :hide-search="false" single-entity="PDV" plural-entity="Vendas Frente de Caixa"
        :moreActions="actions"
        @action="handleButtonMoreActions"
        @new="handleNew" 
        @filter="handleChangeMonth" 
        @search="handleSearch" 
        @refresh="handleRefresh"
        videoButton="true"
        urlVideo="//www.youtube.com/embed/mRtDNkM32PU">
      </bar-list>

      <div class="row mb-2" v-if="!codvabertura">
        <!-- <div class="col-md-3 col-4" v-if="!codvabertura">
          <div class="input-group input-group-sm">
            <input class="form-control form-control-sm" type="text" :placeholder="'Pesquisar Pedido'" v-model="textSearch"
              @keyup.enter="handleTextSearch">
            <span class="input-group-append">
              <button class="btn btn-sm btn-outline-secondary" style="margin-right: 5px" @click="handleTextSearch">
                <i class="fa fa-search" aria-hidden="true"></i>
              </button>
              <button class="btn btn-sm btn-outline-secondary" title="Atualizar Grid" @click="handleRefresh">
                <i class="fa fa-refresh" aria-hidden="true"></i>
              </button>
            </span>
          </div>
        </div> -->
        <div class="col-md-3 col-8" v-if="!codvabertura">
          <div class="input-group input-group-sm">
            <!-- <div class="input-group-prepend">
              <span class="input-group-text">Nota Fiscal</span>
            </div> -->
            <input class="form-control form-control-sm" type="text" :placeholder="'Pesquisar Nota Fiscal ou Chave'"
              v-model="nfSearch" @keyup.enter="handleNfSearch">
            <span class="input-group-append">
              <button class="btn btn-sm btn-outline-secondary" @click="handleNfSearch">
                <i class="fa fa-search" aria-hidden="true"></i>
              </button>
            </span>
          </div>
        </div>
        <div class="col-md-6 col-8" v-if="!codvabertura">
          <pedido-filtro :filter-espera="true" :query="query" @change="changeFiltros"></pedido-filtro>
        </div>
      </div>

      <alert v-if="tipo_devolucao" type="info" title="Devolução de Venda" 
        text="Para laçar uma devolução de venda, localize a venda de origem e clique em 'devolução'">
      </alert>

      <div class="row mb-2" v-if="!tipo_devolucao && caixasList && caixasList.length">
        <div class="col-md-12">
            <span class="lbl-deal-title"> Resumo dos Caixas </span>
        </div>
      </div>
      <div class="row mb-2" v-if="!tipo_devolucao">
        <div class="col-md-3" v-for="(caixa, index) in caixasList" :key="index">
          <div class="nb-dash-card p-2">
            <span class="lbl-deal-title"> {{ caixa.caixa }} </span>
            <span class="data-list w-100"> {{ caixa.operadorabertura }} </span>
            <span class="nb-dash-total w-100 text-center"> <span class="data-list text-center w-100"> Total em Vendas </span> R$ {{ caixa.resumoVendas.total | formatValue(2,true) }} </span>
            <span v-if="caixa.aberto" class="badge badge-green ml-2">{{ caixa.status }} </span>
            <span v-if="!caixa.aberto" class="badge badge-gray ml-2">{{ caixa.status }} </span>
          </div>
        </div>
      </div>

      <div class="default-container position-relative">
        <alert v-if="varejoList.length == 0" type="norecord"></alert>
        <div class="mainbox" v-for="(item, index) in varejoList" v-bind:key="index">
          <div class="box d-flex flex-wrap">
            <div class="col-md-1 col-2">
              <v-label v-if="index==0" class="w-100" label="Pedido"></v-label>
              <span class="data-list">{{ item.npedido }} </span>
            </div>
            <div class="col-md-2 col-2">
              <v-label v-if="index==0" class="w-100" label="Data"></v-label>
              <span class="data-list">{{ item.data | formatDataHora }}</span>
            </div>
            <div class="col-md-1 col-2">
              <v-label v-if="index==0" class="w-100" label="Operador"></v-label>
              <span class="data-list">{{ item.nome_usuario }} </span>
            </div>
            <div class="col-md-1 col-2">
              <v-label v-if="index==0" class="w-100" label="Cliente"></v-label>
              <span class="data-list">{{ item.fantasia }} </span>
            </div>
            <div class="col-md-2 col-2 text-right">
              <v-label v-if="index==0" class="w-100" label="Total do Pedido"></v-label>
              <span class="data-list">R$ {{ item.totger | formatValue(2) }}</span>
            </div>
            <div class="col-md-1 col-3">
              <v-label v-if="index==0" class="w-100" label="NF"></v-label>
              <span class="data-list"> {{ item.nf }} </span>
            </div>
            <div class="col-md-2 ml-auto">
              <!-- <span v-if="item.varejo == 'S'" class="badge badge-success" > Frente de Caixa </span> -->
              <span class="badge" :class="statusColor(item.stpedv, item.tppedv)">{{ textST(item) }}</span>
              <span v-if="item.espera == 'S'" class="badge badge-warning">Em espera</span>
            </div>
            <div class="col-md-2 col-2 align-items-right ml-auto">
              <bar-grid :obj="item" :options="handleBarGrid(item.stpedv)" :moreActions="getActions(item)"
                @action="handleAction" @view="handleCompletEdit(item.codpedv)" @edit="handleCompletEdit(item.codpedv)" @devolucao="handleDevolucao(item.codpedv)">
              </bar-grid>
            </div>
            <div class="col-md-auto col-auto" v-if="item.cpjcpf && item.cpjcpf=='CONSUMIDOR'">
              <v-label class="w-100" label="Cnpj/Cpf"></v-label>
              <span class="data-list"> {{ item.cnpjcpf }} </span>
            </div>
            <div class="col-md-auto col-auto" v-if="item.obspedido">
              <span class="data-list"> {{ item.obspedido }} </span>
            </div>
            <!-- <div class="col-md-auto col-auto" v-if="item.chave">
              <v-label class="w-100" label="Chave da NF"></v-label>
              <span class="data-list"> {{ item.chave }} </span>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <VarejoEmissaoCupom v-if="showEmissaoCupom" :index="cupomCodpedv" tipo="cupomnaofiscal"
      @resultadoemissaocupom="showEmissaoCupom = false"></VarejoEmissaoCupom>

    <DevolucaoForm v-if="showDevolucao" :index="this.codpedv" :crud="crud" @closeform="closeFormDevolucao" />

  </div>
</template>

<style scoped>
.mainbox {
  overflow: visible;
}

.default-container {
  overflow-y: hidden;
}

.box {
  float: none;
}
</style>



// WEBPACK FOOTER //
// src/forms-varejo/varejo-list.vue